angular.module('SpidApp')

.controller('ChangeUserAgenciesController', ['$uibModalInstance', '$scope', 'AgencyService', function ($uibModalInstance, $scope, AgencyService) {
    // the scope has a selectedUser property
    
    AgencyService.all().then(function (agencies) {
        $scope.agencies = agencies.map(function (e) {
            e.isChecked = $scope.selectedUser.getAgencyIds().lastIndexOf(e.id + '') > -1
            return e
        })
    })
    
    $scope.ok = function () {
        var response = $scope.agencies.filter(function (agency) {
            return agency.isChecked
        }).map(function (agency) {
            return agency.id
        }).join(',')
        
        $uibModalInstance.close(response)
    }

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel')
    }
}])
